
const SolutionsSection = () => {
  const solutions = [
    {
      number: '01',
      title: 'Formation Managériale Avancée',
      description: 'Perfectionnez vos compétences de management avec des formations de haut niveau. Leadership, gestion d\'équipe, conduite du changement, intelligence émotionnelle : développez les soft skills essentiels pour exceller dans vos fonctions et préparer votre évolution.',
      benefits: [
        'Leadership et influence',
        'Management d\'équipe performante',
        'Conduite du changement',
        'Intelligence émotionnelle',
      ],
      image: 'https://public.readdy.ai/ai/img_res/1bd321f359f34663f2d39c04817925b5.jpg',
    },
    {
      number: '02',
      title: 'Réseau de Cadres Locaux',
      description: 'Intégrez un cercle exclusif de cadres et managers de votre agglomération. Échangez sur vos pratiques, partagez vos défis, créez des synergies inter-entreprises et développez votre influence locale pour booster votre carrière et celle de votre organisation.',
      benefits: [
        'Cercle de cadres dirigeants',
        'Événements networking premium',
        'Partage de bonnes pratiques',
        'Opportunités de carrière',
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20networking%20event%20for%20executives%20in%20elegant%20venue%2C%20diverse%20group%20of%20managers%20and%20directors%20exchanging%20ideas%20over%20drinks%2C%20upscale%20corporate%20networking%20atmosphere%2C%20modern%20sophisticated%20setting%2C%20high%20quality%20business%20event%20photography&width=800&height=600&seq=cadre-reseau-001&orientation=landscape',
    },
    {
      number: '03',
      title: 'Veille Stratégique & Innovation',
      description: 'Restez à la pointe des tendances de votre secteur et apportez de la valeur à votre entreprise. Accédez à des analyses sectorielles, des études de marché et des innovations pour nourrir votre réflexion stratégique et proposer des solutions différenciantes.',
      benefits: [
        'Analyses sectorielles exclusives',
        'Tendances et innovations',
        'Benchmarking concurrentiel',
        'Rapports stratégiques',
      ],
      image: 'https://readdy.ai/api/search-image?query=Business%20executive%20analyzing%20strategic%20data%20and%20market%20trends%20on%20multiple%20screens%20in%20modern%20office%2C%20professional%20manager%20reviewing%20business%20intelligence%20dashboards%20and%20reports%2C%20contemporary%20corporate%20workspace%20with%20technology%2C%20natural%20lighting%2C%20high%20quality%20business%20photography&width=800&height=600&seq=cadre-veille-001&orientation=landscape',
    },
    {
      number: '04',
      title: 'Coaching de Carrière',
      description: 'Bénéficiez d\'un accompagnement personnalisé pour atteindre vos objectifs professionnels. Définition de votre projet, développement de votre personal branding, préparation aux évolutions : un coach expert vous guide pour maximiser votre potentiel et votre impact.',
      benefits: [
        'Coaching individuel personnalisé',
        'Développement personal branding',
        'Stratégie de carrière',
        'Préparation aux évolutions',
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20executive%20coach%20mentoring%20senior%20manager%20in%20elegant%20modern%20office%2C%20one-on-one%20career%20coaching%20session%20with%20confident%20business%20leader%2C%20premium%20consultation%20environment%20with%20comfortable%20seating%2C%20natural%20lighting%2C%20high%20quality%20executive%20coaching%20photography&width=800&height=600&seq=cadre-coaching-001&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-light/5">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-12 md:mb-20">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-primary-dark mb-3 md:mb-4">
            Nos Solutions pour les Cadres
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-gray-dark max-w-2xl mx-auto">
            Des outils pour développer votre leadership et votre carrière
          </p>
        </div>

        <div className="space-y-16 md:space-y-24">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="relative">
                  <div className="absolute -top-6 -left-6 md:-top-8 md:-left-8 text-6xl md:text-8xl font-bold text-primary-light/20 select-none">
                    {solution.number}
                  </div>
                  <div className="relative space-y-4 md:space-y-6">
                    <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-primary-dark">
                      {solution.title}
                    </h3>
                    <p className="text-sm md:text-base lg:text-lg text-gray-dark leading-relaxed">
                      {solution.description}
                    </p>
                    <ul className="space-y-2 md:space-y-3">
                      {solution.benefits.map((benefit, idx) => (
                        <li key={idx} className="flex items-start gap-3">
                          <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center bg-primary rounded-full flex-shrink-0 mt-0.5">
                            <i className="ri-check-line text-white text-xs"></i>
                          </div>
                          <span className="text-sm md:text-base text-gray-dark">{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div className="rounded-2xl overflow-hidden shadow-xl">
                  <img
                    src={solution.image}
                    alt={solution.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
